import { useQuery } from "@tanstack/react-query"
import { whatsappTemplateQuery } from "../../../lib/templates/whatsapp/whatsappTemplateQuery"

export function useWhatsappTemplateQuery(...args: Parameters<typeof whatsappTemplateQuery>) {
  return useQuery(whatsappTemplateQuery(...args))
}
